import { toast } from 'react-toastify';

import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { findDocumentProtected, findDocument } from '../../processes/document';

import { getCode } from '../../utils/utils'
import * as NavigationUtils from '../../utils/navigation';

import Home from './Home';
import Header from '../../components/Header';
import Container from '../../components/Container';
import { clearMask, formatCpf } from '../../utils/formatter';
import { usePatientDocumentContext } from '../../contexts/PatientDocument';

function HomeContainer() {
	const history = useHistory();
	const code = useMemo(() => getCode(), []);
	const { document, setInfo } = usePatientDocumentContext();

	const [cpf, setCpf] = useState('');
	const [loading, setLoading] = useState(false)
	const [acceptedTerms, setAcceptedTerms] = useState(true);

	const navigateToSignaturePage = useCallback((status) => {
		const url = (status || document?.status) === 'SIGNED' ? `/signature-success?code=${code}` : `/document?code=${code}`

		history.push(url);
	}, [history, document?.status, code]);

	const fetchDocument = useCallback(async () => {
		const filter = {
			code: getCode()
		};

		if (!filter.code) {
			return;
		}

		setLoading(true);

		const { data, error } = await findDocument(filter);

		if (error) {
			if (error.code === 'INVALID_CODE') {
				return NavigationUtils.navigate(history, `/expired/${code || ''}`);
			} else {
				toast.error('Não foi possível buscar as informações do formulário.');
			}
		} else {
			setInfo({
				document: data,
				code
			});

			if (!data.is_protected && data.status === 'SIGNED') {
				navigateToSignaturePage(data.status);
			}
		}

		setLoading(false);
	}, [code, setInfo, navigateToSignaturePage, history]);

	useEffect(() => {
		fetchDocument();
	}, [fetchDocument]);

	const handleFindDocumentProtected = useCallback(async () => {
		const filter = {
			code,
			cpf: clearMask(cpf)
		};

		setLoading(true);

		const { data, error } = await findDocumentProtected(filter);

		setLoading(false);

		if (error) {
			toast.error('CPF inválido!');
		} else {
			document.text = data.text;
			document.destinatary.cpf = filter.cpf;

			navigateToSignaturePage();
		}
	}, [code, cpf, navigateToSignaturePage, document]);

	useEffect(() => {
		if (document?.signature_url) {
			history.push(`/signature-success?code=${code}`);
		}

		return;
	}, [document?.signature_url, code, history])

	const onChangeCpfText = useCallback(({ target }) => {
		const maskedValue = formatCpf(target?.value)

		setCpf(maskedValue);
	}, []);

	const submit = useCallback(() => {
		const action = document.is_protected ? handleFindDocumentProtected : navigateToSignaturePage;

		action();
	}, [document, handleFindDocumentProtected, navigateToSignaturePage]);

    return (
		<Container>
			<Header/>

			<Home
				loading={loading}
				document={document}
				onChangeCpfText={onChangeCpfText}
				cpf={cpf}
				setCpf={setCpf}
				setAcceptedTerms={setAcceptedTerms}
				acceptedTerms={acceptedTerms}
				submit={submit}
			/>
		</Container>
	);
}

export default HomeContainer;
